<template>
  <div :class="['avatar', { avatar_circle: circle }]" :style="style">
    <img :src="src" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: 'AppAvatar',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: 'avatar image'
    },
    size: {
      type: String,
      default: '48px'
    },
    circle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    style() {
      return `
        height: ${this.size};
        min-width: ${this.size};
        width: ${this.size};
        `
    }
  }
}
</script>

<style scoped lang="scss">
.avatar {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  line-height: normal;
  position: relative;
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  &_circle {
    border-radius: 50%;
  }
  & > img {
    border-radius: inherit;
    display: inline-flex;
    height: inherit;
    width: inherit;
    object-fit: cover;
  }

  &__auto-fill > img {
    object-fit: initial;
  }
}
</style>
